import { Route, Routes } from "react-router-dom";
import Unitymodals3D from "./Unitymodals3D";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Model from "./Model";
import SearchResult from "./SearchResult";
// import Unitymodals2D from "./Unitymodals2D";


const Modelmain = () => {
  return (
    <>
      <Routes>
        <Route path="/header" element={<Header />}></Route>
        <Route path="/sidebar" element={<Sidebar />}></Route>
        <Route path="/" element={<Model />} />
        <Route path="/unitymodals3D" element={<Unitymodals3D />} />
        <Route path="/searchResult" element={<SearchResult />} />
      </Routes>
    </>
  );
};

export default Modelmain;
